import {
    Row,Col,Button 
} from 'reactstrap';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { IngestState } from '../../../features/ingest/ingestSlice';
import IngestActions from '../../../features/ingest/ingestActions';
import { useRef } from 'react';

const InvisiblePicker = styled.input`
  display: none;
`;

export default (state: IngestState) => {
    const actions = new IngestActions(useDispatch());
    const hiddenFileInput = useRef<HTMLInputElement>(null);

    return (<Row className="justify-content-end mb-2">
        <Col md="auto" className="mr-auto">
          {state.isCancellable && (
            <Button onClick={() => {}}>Cancel</Button>
          )}
        </Col> 
        <Col md="auto">
        <Button
                onClick={() => hiddenFileInput.current?.click()}
                color="default"
                outline
                className="mr-2"
              >
                Select File...
              </Button>
              <Button
                onClick={() => actions.upload(state)}
                color="default"
                outline
                className="mr-2"                
              >
                Submit File
              </Button>
              <InvisiblePicker
                ref={hiddenFileInput}
                type="file"
                id="file"
                name="file"
                onChange={() => actions.selectUploadFile(hiddenFileInput.current?.files && hiddenFileInput.current?.files[0] )}
              />
        </Col>
    </Row> 
    );
}